/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { TokenManager } from "@okta/okta-auth-js";

const CLIENT_ID = '0oa1w23edrbJOUqAQ1d8';
const ISSUER = 'https://technipfmc.okta.com/oauth2/default';
const OKTA_TESTING_DISABLEHTTPSCHECK = true;
const BASENAME = 'http://localhost:3001';
// BASENAME includes trailing slash
const REDIRECT_URI = `${window.location.origin}`;

export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    responseType: 'code',
    responseMode: 'query',
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
    TokenManager: {
	           autoRenew: true,
	           syncStorage: true
	       }
  },
  resourceServer: {
    messagesUrl: 'http://localhost:44320',
  },
  app: {
    basename: BASENAME,
  },
};
